module.exports = "pegasus_template/assets/themecapture1/charity/100.png";